import type { Story } from '@/store/story-types'

export const ONLINE_STORE_STORY: Story = {
  id: 'online-store',
  name: 'VERDE — Modern Online Store',
  narrative: 'A modern online store with product catalog, detail views, and a full shopping cart experience.',
  goals: ['Browse product catalog', 'View product details', 'Manage shopping cart', 'Complete purchase'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home',
      description: 'Landing page with navbar, hero banner, product grid, store features, and footer',
      blockRef: { category: 'store', blockId: 'store-hero' },
    },
    {
      id: 'pg-product-detail', title: 'Product Detail', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'product-detail',
      description: 'Product detail page with images, description, price, and add-to-cart button',
      blockRef: { category: 'store', blockId: 'product-detail' },
    },
    {
      id: 'pg-cart', title: 'Shopping Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Shopping cart with item list, quantity controls, subtotal, and proceed to checkout',
      blockRef: { category: 'store', blockId: 'shopping-cart' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Product Catalog',
      description: 'Visitor browses the product grid on the home page',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero banner, product grid, and store features section are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Product Detail',
      description: 'Visitor navigates to a product detail page',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'the product detail page shows images, description, price, and add-to-cart button', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Add to Cart',
      description: 'Visitor adds a product to the shopping cart',
      steps: [
        { type: 'given', text: 'the visitor is on the product detail page', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap the Add to Cart button' },
        { type: 'then', text: 'the cart badge updates and the item appears in the cart', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Review Cart and Checkout',
      description: 'Visitor reviews the cart and proceeds to checkout',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they review item quantities and totals' },
        { type: 'then', text: 'the cart displays correct subtotal and a checkout button', linkedPageId: 'cart' },
        { type: 'and', text: 'they can adjust quantities or remove items', linkedFlowId: 'updateCart' },
      ],
    },
  ],
}
